import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Column } from "@faire/web--source/slate/Layout";
import { LoadingSkeleton } from "@faire/web--source/slate/LoadingSkeleton";
import { Spacer } from "@faire/web--source/slate/spacing";
import React from "react";
export var GridV2ProductTilePlaceholder = function() {
    return /*#__PURE__*/ _jsxs(Column, {
        children: [
            /*#__PURE__*/ _jsx(LoadingSkeleton, {
                width: {
                    mobileAndAbove: 286,
                    tabletAndAbove: 290,
                    desktopAndAbove: 312
                },
                height: "",
                aspectRatio: "1"
            }),
            /*#__PURE__*/ _jsxs(Column, {
                children: [
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: "1x"
                    }),
                    /*#__PURE__*/ _jsx(LoadingSkeleton, {
                        width: "100%",
                        height: "16px"
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: "1x"
                    }),
                    /*#__PURE__*/ _jsx(LoadingSkeleton, {
                        width: "75%",
                        height: "16px"
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: "1x"
                    })
                ]
            })
        ]
    });
};
export var GridV2BrandTilePlaceholder = function() {
    return /*#__PURE__*/ _jsxs(Column, {
        children: [
            /*#__PURE__*/ _jsx(LoadingSkeleton, {
                width: {
                    mobileAndAbove: 384,
                    tabletAndAbove: 514,
                    desktopAndAbove: 492
                },
                height: "",
                aspectRatio: "1"
            }),
            /*#__PURE__*/ _jsxs(Column, {
                children: [
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: "1x"
                    }),
                    /*#__PURE__*/ _jsx(LoadingSkeleton, {
                        width: "100%",
                        height: "16px"
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: "1x"
                    }),
                    /*#__PURE__*/ _jsx(LoadingSkeleton, {
                        width: "100%",
                        height: "16px"
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: "1x"
                    })
                ]
            })
        ]
    });
};
export var GridV2GenericTilePlaceholder = function() {
    return /*#__PURE__*/ _jsxs(Column, {
        children: [
            /*#__PURE__*/ _jsx(LoadingSkeleton, {
                width: "100%",
                height: "",
                aspectRatio: "1"
            }),
            /*#__PURE__*/ _jsxs(Column, {
                children: [
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: "1x"
                    }),
                    /*#__PURE__*/ _jsx(LoadingSkeleton, {
                        width: "80%",
                        height: "16px"
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: "1x"
                    })
                ]
            })
        ]
    });
};
